/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file makes it easier to update the theme.
 */

(function() {
  var DISCOUNT_CODE = 'STYLE20';
  var STORAGE_KEY = 'ssStyleFinderSubmittedStyle20v7';
  var HERO_IMAGE = 'https://sareessalwars.com/cdn/shop/files/WhatsAppImage2025-08-26at1.13.59PM.jpg?v=1756197602&width=1600';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function appendStyles() {
    if (document.getElementById('ss-premium-homepage-styles')) return;

    var style = document.createElement('style');
    style.id = 'ss-premium-homepage-styles';
    style.textContent = [
      '.template-index [data-ss-hidden-original-hero="true"] { display: none !important; }',
      '.ss-premium-hero { position: relative; overflow: hidden; min-height: clamp(470px, 58vw, 690px); display: flex; align-items: center; margin: 0 auto 28px; background: #1b0d11; color: #fffaf1; isolation: isolate; }',
      '.ss-premium-hero::before { content: ""; position: absolute; inset: 0; background: radial-gradient(circle at 78% 20%, rgba(197, 157, 95, .24), transparent 28%), linear-gradient(90deg, rgba(27, 13, 17, .98) 0%, rgba(27, 13, 17, .86) 39%, rgba(27, 13, 17, .35) 68%, rgba(27, 13, 17, .08) 100%); z-index: 1; pointer-events: none; }',
      '.ss-premium-hero::after { content: ""; position: absolute; inset: auto 0 0; height: 34%; background: linear-gradient(0deg, rgba(27, 13, 17, .82), transparent); z-index: 1; pointer-events: none; }',
      '.ss-premium-hero__image { position: absolute; inset: 0 0 0 auto; width: min(64vw, 760px); height: 100%; object-fit: contain; object-position: right bottom; z-index: 0; filter: saturate(1.02) contrast(1.02); }',
      '.ss-premium-hero__content { position: relative; z-index: 2; width: min(680px, calc(100% - 32px)); padding: clamp(34px, 7vw, 86px) clamp(20px, 7vw, 92px); }',
      '.ss-premium-hero__eyebrow { display: inline-flex; align-items: center; min-height: 32px; padding: 7px 12px; border: 1px solid rgba(232, 196, 125, .42); color: #f1d79c; background: rgba(255, 255, 255, .08); font-size: 12px; font-weight: 700; text-transform: uppercase; line-height: 1; }',
      '.ss-premium-hero h1 { margin: 18px 0 14px; max-width: 620px; color: #fff7e8; font-family: Georgia, serif; font-size: clamp(42px, 7vw, 82px); line-height: .96; font-weight: 500; }',
      '.ss-premium-hero__copy { max-width: 560px; margin: 0 0 22px; color: rgba(255, 250, 241, .86); font-size: clamp(16px, 2vw, 20px); line-height: 1.55; }',
      '.ss-premium-hero__offer { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin: 0 0 24px; }',
      '.ss-premium-hero__offer-main { color: #fff7e8; font-weight: 800; font-size: clamp(18px, 2vw, 24px); }',
      '.ss-premium-hero__offer-sub { color: rgba(255, 250, 241, .72); font-size: 13px; }',
      '.ss-premium-hero__code { display: inline-flex; align-items: center; min-height: 34px; padding: 8px 13px; border: 1px dashed rgba(232, 196, 125, .75); color: #f8e0a0; background: rgba(248, 224, 160, .1); font-weight: 800; letter-spacing: 0; }',
      '.ss-premium-hero__actions { display: flex; flex-wrap: wrap; gap: 10px; margin: 0 0 24px; }',
      '.ss-premium-btn { display: inline-flex; align-items: center; justify-content: center; min-height: 44px; padding: 12px 18px; border-radius: 4px; border: 1px solid transparent; text-decoration: none; font-weight: 800; line-height: 1; transition: transform .18s ease, background .18s ease, border-color .18s ease; }',
      '.ss-premium-btn:hover { transform: translateY(-1px); text-decoration: none; }',
      '.ss-premium-btn--primary { background: #c59d5f; color: #1b0d11; }',
      '.ss-premium-btn--secondary { border-color: rgba(255, 250, 241, .38); color: #fff7e8; background: rgba(255, 255, 255, .08); }',
      '.ss-premium-hero__trust { display: flex; flex-wrap: wrap; gap: 10px 18px; margin: 0; padding: 0; list-style: none; color: rgba(255, 250, 241, .78); font-size: 13px; }',
      '.ss-premium-hero__trust li { display: flex; align-items: center; gap: 7px; }',
      '.ss-premium-hero__trust li::before { content: ""; width: 6px; height: 6px; border-radius: 999px; background: #c59d5f; flex: 0 0 auto; }',
      '.ss-style-finder { margin: 0 auto 46px; padding: clamp(22px, 4vw, 44px) clamp(16px, 5vw, 56px); background: #fbf7ef; color: #28141a; border-top: 1px solid rgba(83, 33, 44, .1); border-bottom: 1px solid rgba(83, 33, 44, .1); }',
      '.ss-style-finder__shell { max-width: 1160px; margin: 0 auto; display: grid; grid-template-columns: minmax(260px, .72fr) minmax(320px, 1fr); gap: clamp(20px, 4vw, 42px); align-items: stretch; }',
      '.ss-style-finder__intro { background: #2a1018; color: #fff7e8; padding: clamp(22px, 4vw, 38px); border-radius: 6px; display: flex; flex-direction: column; justify-content: space-between; min-height: 390px; }',
      '.ss-style-finder__eyebrow { color: #e7c179; font-size: 12px; font-weight: 800; text-transform: uppercase; }',
      '.ss-style-finder h2 { margin: 14px 0 12px; color: #fff7e8; font-family: Georgia, serif; font-size: clamp(30px, 4vw, 48px); line-height: 1.05; font-weight: 500; }',
      '.ss-style-finder__intro p { margin: 0; color: rgba(255, 247, 232, .82); font-size: 15px; line-height: 1.6; }',
      '.ss-style-finder__gift { margin-top: 24px; border-top: 1px solid rgba(231, 193, 121, .28); padding-top: 20px; display: grid; gap: 10px; }',
      '.ss-style-finder__gift strong { color: #ffe3a5; font-size: 20px; }',
      '.ss-style-finder__gift span { color: rgba(255, 247, 232, .72); font-size: 13px; }',
      '.ss-style-finder__panel { background: #fffdf8; border: 1px solid rgba(83, 33, 44, .12); border-radius: 6px; box-shadow: 0 18px 50px rgba(45, 20, 25, .08); padding: clamp(20px, 4vw, 34px); min-height: 390px; }',
      '.ss-style-finder__meta { display: grid; gap: 10px; margin-bottom: 20px; }',
      '.ss-style-finder__topline { display: flex; align-items: center; justify-content: space-between; gap: 12px; color: #6c4b50; font-size: 13px; font-weight: 700; }',
      '.ss-style-finder__bar { height: 6px; background: #efe5d8; border-radius: 999px; overflow: hidden; }',
      '.ss-style-finder__bar-fill { display: block; width: 14.28%; height: 100%; background: #6d202d; transition: width .22s ease; }',
      '.ss-style-step { display: none; min-height: 250px; }',
      '.ss-style-step.is-active { display: block; animation: ssStepIn .2s ease; }',
      '@keyframes ssStepIn { from { opacity: 0; transform: translateX(10px); } to { opacity: 1; transform: translateX(0); } }',
      '.ss-style-step h3 { margin: 0 0 8px; color: #28141a; font-size: clamp(21px, 2.5vw, 30px); line-height: 1.16; }',
      '.ss-style-step__hint { margin: 0 0 18px; color: #71555a; font-size: 14px; line-height: 1.5; }',
      '.ss-style-field { display: grid; gap: 7px; margin-bottom: 14px; }',
      '.ss-style-field label, .ss-style-label { color: #3c2228; font-weight: 800; font-size: 13px; }',
      '.ss-style-field input, .ss-style-field select { width: 100%; min-height: 46px; border: 1px solid rgba(83, 33, 44, .22); border-radius: 4px; background: #fff; padding: 10px 12px; color: #28141a; font-size: 15px; }',
      '.ss-style-field input:focus, .ss-style-field select:focus { outline: 2px solid rgba(109, 32, 45, .18); border-color: #6d202d; }',
      '.ss-style-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }',
      '.ss-choice { position: relative; display: block; cursor: pointer; }',
      '.ss-choice input { position: absolute; opacity: 0; pointer-events: none; }',
      '.ss-choice span { min-height: 58px; display: flex; align-items: center; justify-content: center; text-align: center; border: 1px solid rgba(83, 33, 44, .16); background: #fffaf2; color: #321a20; border-radius: 5px; padding: 12px; font-weight: 800; line-height: 1.25; transition: border-color .18s ease, background .18s ease, box-shadow .18s ease; }',
      '.ss-choice:hover span { border-color: rgba(109, 32, 45, .46); }',
      '.ss-choice input:checked + span { border-color: #6d202d; background: #f5eadc; box-shadow: inset 0 0 0 1px #6d202d; }',
      '.ss-style-row { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }',
      '.ss-style-consent { display: flex; align-items: flex-start; gap: 10px; color: #584247; font-size: 13px; line-height: 1.45; }',
      '.ss-style-consent input { margin-top: 3px; width: 16px; height: 16px; flex: 0 0 auto; }',
      '.ss-style-finder__error { display: none; margin: 14px 0 0; color: #8b1f2b; font-size: 13px; font-weight: 700; }',
      '.ss-style-finder__error.is-visible { display: block; }',
      '.ss-style-finder__nav { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: 22px; }',
      '.ss-style-finder__nav-group { display: flex; gap: 10px; margin-left: auto; }',
      '.ss-style-nav-btn { min-height: 42px; border-radius: 4px; border: 1px solid rgba(83, 33, 44, .22); background: #fff; color: #321a20; padding: 10px 15px; font-weight: 800; cursor: pointer; }',
      '.ss-style-nav-btn[disabled] { opacity: .45; cursor: default; }',
      '.ss-style-nav-btn--primary { background: #6d202d; border-color: #6d202d; color: #fffaf2; }',
      '.ss-style-finder__success { display: none; background: #fff8e9; border: 1px solid rgba(197, 157, 95, .42); border-radius: 5px; padding: 20px; margin-top: 18px; }',
      '.ss-style-finder__success.is-visible { display: block; }',
      '.ss-style-finder__success h3 { margin: 0 0 8px; color: #28141a; font-size: 24px; }',
      '.ss-style-finder__success p { margin: 0 0 12px; color: #5e464b; line-height: 1.55; }',
      '.ss-style-code { display: inline-flex; align-items: center; min-height: 40px; padding: 10px 14px; border-radius: 4px; border: 1px dashed #6d202d; color: #6d202d; background: #fff; font-weight: 900; }',
      '@media (max-width: 860px) { .ss-premium-hero { min-height: 600px; align-items: flex-end; } .ss-premium-hero::before { background: linear-gradient(180deg, rgba(27, 13, 17, .2) 0%, rgba(27, 13, 17, .76) 46%, rgba(27, 13, 17, .97) 100%); } .ss-premium-hero__image { width: 100%; height: 62%; object-fit: contain; object-position: center top; opacity: .86; } .ss-premium-hero__content { padding-top: 260px; } .ss-style-finder__shell { grid-template-columns: 1fr; } .ss-style-finder__intro { min-height: 0; } }',
      '@media (max-width: 560px) { .ss-premium-hero { min-height: 630px; } .ss-premium-hero h1 { font-size: 44px; } .ss-premium-hero__actions, .ss-style-finder__nav, .ss-style-finder__nav-group { width: 100%; } .ss-premium-btn, .ss-style-nav-btn { width: 100%; } .ss-style-grid, .ss-style-row { grid-template-columns: 1fr; } .ss-style-finder__topline { align-items: flex-start; flex-direction: column; } }',
      '.ss-premium-hero { min-height: clamp(360px, 42vw, 500px); margin-bottom: 0; }',
      '.ss-premium-hero__content { padding: clamp(28px, 5vw, 58px) clamp(18px, 6vw, 74px); }',
      '.ss-premium-hero h1 { font-size: clamp(38px, 5.8vw, 66px); margin-bottom: 10px; }',
      '.ss-premium-hero__copy { max-width: 520px; margin-bottom: 16px; }',
      '.ss-premium-hero__offer { margin-bottom: 18px; }',
      '.ss-premium-hero__image { width: min(72vw, 900px); }',
      '.ss-style-finder { margin: 0 auto 20px; padding: 12px clamp(14px, 4vw, 42px); background: #fbf7ef; }',
      '.ss-style-finder__shell { grid-template-columns: 1fr !important; max-width: 1160px; gap: 0; }',
      '.ss-style-finder__intro { min-height: 0; padding: 18px clamp(18px, 3vw, 28px); display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 14px 22px; align-items: center; }',
      '.ss-style-finder__intro h2 { margin: 6px 0 6px; font-size: clamp(24px, 3vw, 34px); }',
      '.ss-style-finder__intro p { max-width: 690px; }',
      '.ss-style-finder__gift { margin-top: 0; padding-top: 0; border-top: 0; justify-items: end; align-content: center; }',
      '.ss-style-finder__gift strong { font-size: 18px; }',
      '.ss-style-finder__open { min-height: 42px; margin-top: 10px; border: 1px solid #e7c179; background: #e7c179; color: #2a1018; border-radius: 4px; padding: 10px 15px; font-weight: 900; cursor: pointer; white-space: nowrap; }',
      '.ss-style-finder__panel { display: none; }',
      '.ss-style-finder.is-open::before { content: ""; position: fixed; inset: 0; background: rgba(19, 8, 11, .46); z-index: 2147482998; }',
      '.ss-style-finder.is-open .ss-style-finder__panel { display: block; position: fixed; top: 16px; right: 16px; bottom: 16px; width: min(560px, calc(100vw - 32px)); min-height: 0; overflow: auto; z-index: 2147482999; animation: ssDrawerIn .22s ease; }',
      '.ss-style-finder__close { float: right; min-height: 34px; margin: -6px -4px 12px 14px; border: 1px solid rgba(83, 33, 44, .18); background: #fffaf2; color: #321a20; border-radius: 4px; padding: 7px 11px; font-weight: 800; cursor: pointer; }',
      '@keyframes ssDrawerIn { from { opacity: 0; transform: translateX(26px); } to { opacity: 1; transform: translateX(0); } }',
      '@media (max-width: 860px) { .ss-premium-hero { min-height: 500px; } .ss-premium-hero__image { height: 54%; width: 100%; } .ss-premium-hero__content { padding-top: 210px; padding-bottom: 30px; } }',
      '@media (max-width: 640px) { .ss-premium-hero { min-height: 520px; } .ss-premium-hero h1 { font-size: 40px; } .ss-premium-hero__trust { display: none; } .ss-style-finder__intro { grid-template-columns: 1fr; } .ss-style-finder__gift { justify-items: start; } .ss-style-finder__open { width: 100%; } .ss-style-finder.is-open .ss-style-finder__panel { inset: 8px; width: calc(100vw - 16px); } }',
      '.ss-premium-hero { height: clamp(760px, 76vw, 980px); min-height: 760px; align-items: flex-start; }',
      '.ss-premium-hero__image { width: min(62vw, 780px); object-fit: cover; object-position: center top; }',
      '.ss-premium-hero__content { padding-top: clamp(22px, 3vw, 38px); padding-bottom: clamp(50px, 7vw, 92px); }',
      '.ss-premium-hero h1 { margin: 14px 0 10px; }',
      '.ss-premium-hero__copy { margin-bottom: 14px; line-height: 1.42; }',
      '.ss-premium-hero__offer { margin-bottom: 10px; }',
      '.ss-premium-hero__offer-sub { display: none; }',
      '@media (max-width: 860px) { .ss-premium-hero { height: 760px; min-height: 760px; } .ss-premium-hero__image { height: 62%; width: 100%; object-fit: cover; object-position: center top; } .ss-premium-hero__content { padding-top: 280px; } }',
      '@media (max-width: 640px) { .ss-premium-hero { height: 720px; min-height: 720px; } .ss-premium-hero__content { padding-top: 245px; } }',
      '.ss-style-finder:not(.is-open) { padding-top: 8px; padding-bottom: 8px; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__intro { padding: 13px 18px; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__intro p { display: none; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__gift span { display: none; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__intro h2 { font-size: clamp(22px, 2.4vw, 30px); margin: 4px 0 0; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__gift strong { font-size: 16px; }',
      '.ss-style-finder:not(.is-open) .ss-style-finder__open { margin-top: 8px; }',
      '@media (max-width: 640px) { .ss-style-finder:not(.is-open) .ss-style-finder__intro p { display: block; font-size: 13px; } .ss-style-finder:not(.is-open) .ss-style-finder__gift span { display: block; } }',
    ].join('\n');

    document.head.appendChild(style);
  }

  function buildHero() {
    var hero = document.createElement('section');
    hero.id = 'ss-premium-hero';
    hero.className = 'ss-premium-hero';
    hero.setAttribute('aria-label', 'SareesSalwars premium collection');
    hero.innerHTML = [
      '<img class="ss-premium-hero__image" src="' + HERO_IMAGE + '" alt="Olive Designer Silk Anarkali Suit">',
      '<div class="ss-premium-hero__content">',
        '<span class="ss-premium-hero__eyebrow">New customer gift</span>',
        '<h1>SareesSalwars</h1>',
        '<p class="ss-premium-hero__copy">Elegant Indian fashion for weddings, festivals and unforgettable celebrations. Premium sarees, salwar sets and lehengas selected to feel special from the first look.</p>',
        '<div class="ss-premium-hero__offer">',
          '<span class="ss-premium-hero__offer-main">EUR 20 off from EUR 120</span>',
          '<span class="ss-premium-hero__code">Unlock code</span>',
          '<span class="ss-premium-hero__offer-sub">Complete the style finder to reveal your code.</span>',
        '</div>',
        '<div class="ss-premium-hero__actions">',
          '<a class="ss-premium-btn ss-premium-btn--primary" href="/collections/all">Shop the collection</a>',
          '<a class="ss-premium-btn ss-premium-btn--secondary" href="#ss-style-finder">Find my style</a>',
        '</div>',
        '<ul class="ss-premium-hero__trust" aria-label="Store highlights">',
          '<li>18,500+ customers worldwide</li>',
          '<li>Product reviews powered by Loox</li>',
          '<li>Secure checkout</li>',
        '</ul>',
      '</div>'
    ].join('');
    return hero;
  }

  function buildStyleFinder() {
    var section = document.createElement('section');
    section.id = 'ss-style-finder';
    section.className = 'ss-style-finder';
    section.setAttribute('aria-labelledby', 'ss-style-title');
    section.innerHTML = [
      '<div class="ss-style-finder__shell">',
        '<div class="ss-style-finder__intro">',
          '<div>',
            '<span class="ss-style-finder__eyebrow">Personal Style Finder</span>',
            '<h2 id="ss-style-title">Find your look in 60 seconds</h2>',
            '<p>Answer a few quick questions and tell us what you would love to see more of. Your answers help us choose better collections for weddings, Eid, parties and everyday elegance.</p>',
          '</div>',
          '<div class="ss-style-finder__gift">',
            '<strong>EUR 20 gift after the style finder</strong>',
            '<span>Minimum order EUR 120. One use per customer. Code appears after your submission.</span>',
            '<button class="ss-style-finder__open" type="button" data-ss-open-finder>Open Style Finder</button>',
          '</div>',
        '</div>',
        '<div class="ss-style-finder__panel">',
          '<button class="ss-style-finder__close" type="button" data-ss-close-finder>Close</button>',
          '<form class="ss-style-form" novalidate>',
            '<div class="ss-style-finder__meta">',
              '<div class="ss-style-finder__topline"><span data-ss-progress-text>Step 1 of 6</span><span>EUR 20 code</span></div>',
              '<div class="ss-style-finder__bar" aria-hidden="true"><span class="ss-style-finder__bar-fill" data-ss-progress-bar></span></div>',
            '</div>',
            '<div class="ss-style-step is-active" data-step="0">',
              '<h3>Where should we send your style gift?</h3>',
              '<p class="ss-style-step__hint">Enter your email first, then answer the short style questions.</p>',
              '<div class="ss-style-field"><label for="ss-style-email">Email address</label><input id="ss-style-email" name="email" type="email" autocomplete="email" placeholder="you@example.com" required></div>',
              '<div class="ss-style-field"><label for="ss-style-name">Name (optional)</label><input id="ss-style-name" name="name" type="text" autocomplete="name" placeholder="Your name"></div>',
            '</div>',
            '<div class="ss-style-step" data-step="1">',
              '<h3>What are you shopping for?</h3>',
              '<p class="ss-style-step__hint">Pick the occasion that matters most right now.</p>',
              '<div class="ss-style-grid">',
                choice('occasion', 'Wedding guest', true),
                choice('occasion', 'Eid or festival', false),
                choice('occasion', 'Party or reception', false),
                choice('occasion', 'Everyday elegance', false),
              '</div>',
            '</div>',
            '<div class="ss-style-step" data-step="2">',
              '<h3>Which collection should we focus on?</h3>',
              '<p class="ss-style-step__hint">This helps us understand what customers want more of.</p>',
              '<div class="ss-style-grid">',
                choice('category', 'Sarees', true),
                choice('category', 'Salwar sets', false),
                choice('category', 'Anarkali gowns', false),
                choice('category', 'Designer lehengas', false),
              '</div>',
            '</div>',
            '<div class="ss-style-step" data-step="3">',
              '<h3>Which size range should feel easy to find?</h3>',
              '<p class="ss-style-step__hint">Your answer helps us improve stock and filters.</p>',
              '<div class="ss-style-grid">',
                choice('fit', 'XS to S', true),
                choice('fit', 'M to L', false),
                choice('fit', 'XL to XXL', false),
                choice('fit', 'Plus size', false),
              '</div>',
            '</div>',
            '<div class="ss-style-step" data-step="4">',
              '<h3>Which colors attract you most?</h3>',
              '<p class="ss-style-step__hint">Choose the palette you would click first.</p>',
              '<div class="ss-style-grid">',
                choice('color', 'Jewel tones', true),
                choice('color', 'Pastels', false),
                choice('color', 'Cream and gold', false),
                choice('color', 'Bold festive', false),
              '</div>',
            '</div>',
            '<div class="ss-style-step" data-step="5">',
              '<h3>When do you need the outfit?</h3>',
              '<p class="ss-style-step__hint">Last step. This also helps us plan ready-to-ship products.</p>',
              '<div class="ss-style-row">',
                '<div class="ss-style-field"><label for="ss-style-timeline">Timeline</label><select id="ss-style-timeline" name="timeline" required><option value="">Select</option><option>As soon as possible</option><option>Within 2 weeks</option><option>Within 1 month</option><option>Just browsing</option></select></div>',
                '<div class="ss-style-field"><label for="ss-style-budget">Budget</label><select id="ss-style-budget" name="budget" required><option value="">Select</option><option>Under EUR 70</option><option>EUR 70 to EUR 120</option><option>EUR 120 to EUR 200</option><option>Premium styles</option></select></div>',
              '</div>',
              '<label class="ss-style-consent"><input type="checkbox" name="consent" value="Yes" required><span>I agree that SareesSalwars may contact me about my style finder answers and offer. I can unsubscribe or request deletion anytime.</span></label>',
            '</div>',
            '<p class="ss-style-finder__error" role="alert"></p>',
            '<div class="ss-style-finder__nav">',
              '<button class="ss-style-nav-btn" type="button" data-ss-back disabled>Back</button>',
              '<div class="ss-style-finder__nav-group">',
                '<button class="ss-style-nav-btn ss-style-nav-btn--primary" type="button" data-ss-next>Next</button>',
                '<button class="ss-style-nav-btn ss-style-nav-btn--primary" type="submit" data-ss-submit hidden>Reveal ' + DISCOUNT_CODE + '</button>',
              '</div>',
            '</div>',
          '</form>',
          '<div class="ss-style-finder__success" data-ss-success>',
            '<h3>Your EUR 20 code is ready</h3>',
            '<p>Use this code at checkout for EUR 20 off your order from EUR 120. It is limited to one use per customer.</p>',
            '<span class="ss-style-code">' + DISCOUNT_CODE + '</span>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
    return section;
  }

  function choice(name, value, required) {
    return '<label class="ss-choice"><input type="radio" name="' + name + '" value="' + value + '"' + (required ? ' required' : '') + '><span>' + value + '</span></label>';
  }

  function getFormValues(form) {
    var values = {};
    new FormData(form).forEach(function(value, key) {
      values[key] = value;
    });
    return values;
  }

  function setHiddenField(form, name, value) {
    var field = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function hasStoredSubmission() {
    try {
      return Boolean(window.localStorage && window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return false;
    }
  }

  function rememberSubmission() {
    try {
      if (window.localStorage) window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (error) {}
  }

  function submitToContactForm(form, onSuccess, onError) {
    var values = getFormValues(form);
    var lines = [
      'Personal Style Finder submission',
      'Email: ' + (values.email || ''),
      'Name: ' + (values.name || ''),
      'Occasion: ' + (values.occasion || ''),
      'Preferred category: ' + (values.category || ''),
      'Size range: ' + (values.fit || ''),
      'Color palette: ' + (values.color || ''),
      'Timeline: ' + (values.timeline || ''),
      'Budget: ' + (values.budget || ''),
      'Consent: ' + (values.consent || ''),
      'Discount shown: ' + DISCOUNT_CODE + ' - EUR 20 off from EUR 120'
    ];

    var frameName = 'ss-style-finder-contact-frame';
    var iframe = document.querySelector('iframe[name="' + frameName + '"]');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.name = frameName;
      iframe.title = 'Style finder submission';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }

    setHiddenField(form, 'form_type', 'contact');
    setHiddenField(form, 'utf8', '\u2713');
    setHiddenField(form, 'contact[email]', values.email || '');
    setHiddenField(form, 'contact[name]', values.name || 'Style Finder');
    setHiddenField(form, 'contact[body]', lines.join('\n'));

    form.method = 'post';
    form.action = '/contact#ss-style-finder';
    form.target = frameName;

    var nativeSubmit = form.querySelector('[data-ss-native-submit]');
    if (!nativeSubmit) {
      nativeSubmit = document.createElement('button');
      nativeSubmit.type = 'submit';
      nativeSubmit.setAttribute('data-ss-native-submit', 'true');
      nativeSubmit.tabIndex = -1;
      nativeSubmit.style.display = 'none';
      form.appendChild(nativeSubmit);
    }

    var finished = false;
    function done(source) {
      if (finished) return;
      finished = true;
      clearTimeout(fallbackTimer);
      iframe.removeEventListener('load', onFrameLoad);
      form.setAttribute('data-ss-submit-result', source || 'load');
      onSuccess();
    }

    function onFrameLoad() {
      done('load');
    }

    var fallbackTimer = setTimeout(function() {
      done('timeout');
    }, 4200);
    iframe.addEventListener('load', onFrameLoad);

    try {
      form.dataset.ssNativeSubmit = 'true';
      nativeSubmit.click();
    } catch (error) {
      delete form.dataset.ssNativeSubmit;
      clearTimeout(fallbackTimer);
      iframe.removeEventListener('load', onFrameLoad);
      onError(error);
    }
  }


  function setupStyleFinder(section) {
    var form = section.querySelector('.ss-style-form');
    var steps = Array.prototype.slice.call(section.querySelectorAll('.ss-style-step'));
    var backButton = section.querySelector('[data-ss-back]');
    var nextButton = section.querySelector('[data-ss-next]');
    var submitButton = section.querySelector('[data-ss-submit]');
    var progressText = section.querySelector('[data-ss-progress-text]');
    var progressBar = section.querySelector('[data-ss-progress-bar]');
    var errorBox = section.querySelector('.ss-style-finder__error');
    var successBox = section.querySelector('[data-ss-success]');
    var openButton = section.querySelector('[data-ss-open-finder]');
    var closeButton = section.querySelector('[data-ss-close-finder]');
    var currentStep = 0;

    if (!form || !steps.length) return;

    function openFinder() {
      section.classList.add('is-open');
      setTimeout(function() {
        var firstField = section.querySelector('.ss-style-step.is-active input, .ss-style-step.is-active select, .ss-style-step.is-active button');
        if (firstField && firstField.focus) firstField.focus();
      }, 120);
    }

    function closeFinder() {
      section.classList.remove('is-open');
    }

    if (openButton) openButton.addEventListener('click', openFinder);
    if (closeButton) closeButton.addEventListener('click', closeFinder);
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && section.classList.contains('is-open')) closeFinder();
    });
    Array.prototype.slice.call(document.querySelectorAll('a[href="#ss-style-finder"]')).forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        openFinder();
      });
    });
    if (window.location && window.location.hash === '#ss-style-finder') openFinder();

    function setError(message) {
      errorBox.textContent = message || '';
      errorBox.classList.toggle('is-visible', Boolean(message));
    }

    function validateCurrentStep() {
      var fields = Array.prototype.slice.call(steps[currentStep].querySelectorAll('input, select, textarea'));
      for (var i = 0; i < fields.length; i += 1) {
        if (!fields[i].checkValidity()) {
          setError('Please complete this step before continuing.');
          fields[i].reportValidity();
          return false;
        }
      }
      setError('');
      return true;
    }

    function updateStep() {
      steps.forEach(function(step, index) {
        step.classList.toggle('is-active', index === currentStep);
      });
      progressText.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;
      progressBar.style.width = (((currentStep + 1) / steps.length) * 100) + '%';
      backButton.disabled = currentStep === 0;
      nextButton.hidden = currentStep === steps.length - 1;
      submitButton.hidden = currentStep !== steps.length - 1;
    }

    nextButton.addEventListener('click', function() {
      if (!validateCurrentStep()) return;
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      updateStep();
    });

    backButton.addEventListener('click', function() {
      currentStep = Math.max(currentStep - 1, 0);
      setError('');
      updateStep();
    });

    form.addEventListener('submit', function(event) {
      if (form.dataset.ssNativeSubmit === 'true') {
        delete form.dataset.ssNativeSubmit;
        return;
      }
      event.preventDefault();
      if (!validateCurrentStep() || !form.checkValidity()) {
        setError('Please complete the final step before revealing your code.');
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
      submitToContactForm(form, function() {
        rememberSubmission();
        form.style.display = 'none';
        successBox.classList.add('is-visible');
        if (openButton) openButton.textContent = 'Show my code';
        openFinder();
        setError('');
      }, function() {
        submitButton.disabled = false;
        submitButton.textContent = 'Reveal ' + DISCOUNT_CODE;
        setError('Something went wrong. Please try again or contact Support@sareessalwars.com.');
      });
    });

    if (hasStoredSubmission()) {
      form.style.display = 'none';
      successBox.classList.add('is-visible');
      if (openButton) openButton.textContent = 'Show my code';
    }

    updateStep();
  }

  function injectPremiumHomepage() {
    if (!document.body.classList.contains('template-index')) return;

    appendStyles();

    var existingHero = document.getElementById('ss-premium-hero');
    var existingFinder = document.getElementById('ss-style-finder');
    if (existingHero) existingHero.remove();
    if (existingFinder) existingFinder.remove();

    var oldHero = document.querySelector('.index-hero');
    var oldHeroSection = oldHero ? oldHero.closest('.shopify-section') : null;
    var firstMainSection = document.querySelector('main .shopify-section');
    var anchor = oldHeroSection || firstMainSection || document.querySelector('main') || document.body;
    var parent = anchor.parentNode || document.body;
    var hero = buildHero();
    var finder = buildStyleFinder();

    if (oldHeroSection) {
      parent.insertBefore(hero, oldHeroSection);
      hero.insertAdjacentElement('afterend', finder);
      oldHeroSection.setAttribute('data-ss-hidden-original-hero', 'true');
      oldHeroSection.style.display = 'none';
    } else if (firstMainSection && firstMainSection.nextSibling) {
      firstMainSection.parentNode.insertBefore(hero, firstMainSection.nextSibling);
      hero.insertAdjacentElement('afterend', finder);
    } else {
      parent.insertBefore(hero, anchor.firstChild || null);
      hero.insertAdjacentElement('afterend', finder);
    }

    setupStyleFinder(finder);
  }

  onReady(injectPremiumHomepage);
})();
